import { formatCurrency, formatNumber, formatCompactCurrency } from '../utils';

interface ComparisonSummaryProps {
  currentTotal: number;
  comparisonTotal: number;
  currentCount: number;
  comparisonCount: number;
  currentLabel: string;
  comparisonLabel: string;
}

export function ComparisonSummary({
  currentTotal,
  comparisonTotal,
  currentCount,
  comparisonCount,
  currentLabel,
  comparisonLabel,
}: ComparisonSummaryProps): JSX.Element {
  const totalDelta = comparisonTotal > 0 ? ((currentTotal - comparisonTotal) / comparisonTotal) * 100 : 0;
  const absoluteDelta = currentTotal - comparisonTotal;

  return (
    <div className="flex items-center gap-6 py-4 px-6 bg-gradient-to-br from-brand-dark-light to-brand-dark rounded-monumenta border border-brand-dark-lighter mb-4 flex-wrap">
      {/* Current Period */}
      <div className="text-center min-w-[140px]">
        <div className="text-[0.7rem] text-brand-gray uppercase mb-1 font-display">
          Periodo Atual
        </div>
        <div className="text-xl font-bold text-brand-primary font-display">
          {formatCurrency(currentTotal)}
        </div>
        <div className="text-xs text-brand-gray font-body">
          {formatNumber(currentCount)} registros • {currentLabel}
        </div>
      </div>

      <span className="text-xl text-brand-dark-lighter">vs</span>

      {/* Comparison Period */}
      <div className="text-center min-w-[140px]">
        <div className="text-[0.7rem] text-brand-gray uppercase mb-1 font-display">
          Periodo Anterior
        </div>
        <div className="text-xl font-bold text-brand-gray-dark font-display">
          {formatCurrency(comparisonTotal)}
        </div>
        <div className="text-xs text-brand-gray font-body">
          {formatNumber(comparisonCount)} registros • {comparisonLabel}
        </div>
      </div>

      {/* Delta */}
      <div className={`text-center py-3 px-5 rounded-lg min-w-[100px] ${totalDelta >= 0 ? 'bg-success/15' : 'bg-error/15'}`}>
        <div className={`text-2xl font-bold font-display ${totalDelta >= 0 ? 'text-success' : 'text-error'}`}>
          {totalDelta >= 0 ? '↑' : '↓'} {Math.abs(totalDelta).toFixed(1)}%
        </div>
        <div className={`text-xs font-body ${totalDelta >= 0 ? 'text-success' : 'text-error'}`}>
          {absoluteDelta >= 0 ? '+' : ''}{formatCompactCurrency(absoluteDelta)}
        </div>
      </div>
    </div>
  );
}
